const axios = require('axios');
const { BigNumber } = require('ethers');

const {
  getTotalETHTopUpsInGwei
} = require('./stakehouse-subgraph.service');

const FINALITY_CHECKPOINTS = '/eth/v1/beacon/states/head/finality_checkpoints'

// this will only get check pointed i.e. finalized validator state
const VALIDATOR_STATE_ENDPOINT = (blsPubKey) => {
  return `/eth/v1/beacon/states/finalized/validators/0x${blsPubKey}`
}

class BeaconChainService {
  constructor(providerUrl, subgraphEndpoint) {
    if (!providerUrl) {
      throw new Error('Consensus URL is null')
    }

    this.client = axios.create({
      baseURL: providerUrl
    })

    this.subgraphEndpoint = subgraphEndpoint
  }

  async getFinalizedEpoch() {
    let axiosResponse

    try {
      axiosResponse = await this.client.get(FINALITY_CHECKPOINTS)
    } catch (e) {
      throw new Error('Failed to get finalized epoch')
    }

    const apiData = axiosResponse.data
    const {finalized} = apiData.data
    return parseInt(finalized.epoch)
  }

  async getFinalisedEpochReport(blsPubKey) {
    let axiosResponse

    try {
      axiosResponse = await this.client.get(VALIDATOR_STATE_ENDPOINT(blsPubKey))
    } catch (e) {
      throw new Error('Failed to get validator state')
    }

    const apiData = axiosResponse.data

    const { balance, validator } = apiData.data
    const {
      pubkey,
      withdrawal_credentials,
      effective_balance,
      slashed,
      activation_eligibility_epoch,
      exit_epoch,
      withdrawable_epoch
    } = validator

    return {
        blsPublicKey: pubkey.slice(2),
        withdrawalCredentials: withdrawal_credentials.slice(2),
        slashed,
        activeBalance: balance,
        effectiveBalance: effective_balance,
        exitEpoch: exit_epoch,
        activationEpoch: activation_eligibility_epoch,
        withdrawalEpoch: withdrawable_epoch,
        currentCheckpointEpoch: await this.getFinalizedEpoch()
    }
  }
}

module.exports = BeaconChainService
